import { LanguageToggle } from "@/ui/components/language-toggle.tsx";

interface ClearLayoutProps {
  children: React.ReactNode;
}
const ClearLayout = ({ children }: ClearLayoutProps) => {
  return (
    <div className={"flex flex-col  justify-center items-center bg-background h-screen w-full"}>
      {/* The auth screens render outside the dashboard header, so the switcher
          lives here — a user has to be able to pick a language before signing in. */}
      <div className={"absolute top-4 right-4"}>
        <LanguageToggle />
      </div>
      <div className={"container px-8 pb-8 "}>
        {children}
      </div>
    </div>
  );
};

export default ClearLayout;
